// extracted by mini-css-extract-plugin
export var numpadContainer = "_sg-1";
export var phoneButton = "_sg-0";